export type LogoutReason = 'expired' | 'revoked' | 'manual' | 'missing_token'

const LOGOUT_REASON_STORAGE_KEY = 'escribonauta_logout_reason'

const LOGOUT_REASON_MESSAGES: Record<'expired' | 'revoked', string> = {
  expired: 'Tu sesión expiró. Vuelve a iniciar sesión.',
  revoked: 'Se cerró la sesión en este dispositivo. Vuelve a iniciar sesión.',
}

export function extractRefreshFailureReason(error: unknown): string | null {
  const responseData = (error as { response?: { data?: any } } | null)?.response?.data
  return responseData?.reason || responseData?.data?.reason || null
}

export function markMissingRefreshToken(error: unknown) {
  if (error && typeof error === 'object') {
    Object.defineProperty(error, 'isMissingRefreshToken', {
      value: true,
      enumerable: false,
    })
  }
}

export function isMissingRefreshTokenError(error: unknown): boolean {
  return !!(
    error
    && typeof error === 'object'
    && (error as { isMissingRefreshToken?: boolean }).isMissingRefreshToken
  )
}

export function logoutReasonFromRefreshError(error: unknown): Exclude<LogoutReason, 'manual'> {
  if (isMissingRefreshTokenError(error)) {
    return 'missing_token'
  }
  if (extractRefreshFailureReason(error) === 'SESSION_EXPIRED') {
    return 'expired'
  }
  return 'revoked'
}

/** Local chapter mirrors stay on device across session end so users can recover after re-login. */
export function shouldKeepChapterBackups(_reason: LogoutReason): boolean {
  return true
}

export function persistLogoutReason(reason: LogoutReason) {
  if (reason === 'manual') {
    return
  }
  try {
    const storedReason = reason === 'missing_token' ? 'expired' : reason
    sessionStorage.setItem(LOGOUT_REASON_STORAGE_KEY, storedReason)
  } catch {
    // Ignore quota / private-mode failures; the toast is optional.
  }
}

export function consumeLogoutReasonMessage(): string | null {
  try {
    const reason = sessionStorage.getItem(LOGOUT_REASON_STORAGE_KEY)
    sessionStorage.removeItem(LOGOUT_REASON_STORAGE_KEY)
    if (reason === 'expired' || reason === 'missing_token') {
      return LOGOUT_REASON_MESSAGES.expired
    }
    if (reason === 'revoked') {
      return LOGOUT_REASON_MESSAGES.revoked
    }
    return null
  } catch {
    return null
  }
}
